import logo from './logo.webp';

export const sharedAssets = {
  logo,
};
